import httpUtils from '../utils/http-utils';
import { API_PATH } from '../config/app-config';

// Centralized feature-config endpoint (Phase 3): /api/v1/admin/feature-config
const SERVICE_NAME = API_PATH.FEATURE_CONFIG;

const list = () => {
    return httpUtils.get(SERVICE_NAME);
}

const update = (payload) => {
    return httpUtils.put(SERVICE_NAME, payload);
}

const featureConfigApi = {
    list,
    update
}

export default featureConfigApi;
